import { Addendum, IReport, IReportWorkflowExamService } from '../services/report-workflow-exam.service';
import { EcgChartState, SeSignRequestData, SignType } from './estensasign.model';
import { ISissObscurationInfo, ISissPatientInfo, ISissReportInfo } from 'estensa-module';

export type MassiveApproveParams = {
    ecgService: IReportWorkflowExamService;
    visitService: IReportWorkflowExamService;
    ecgReports: IReport[];
    visitReports: IReport[];
    userId: string;
    print: boolean;
    addendum?: Addendum;
    isDeferred?: boolean;
    isFromWorklist?: boolean;
    displayedSettings?: EcgChartState;
};
export type MassiveSignParams = {
    ecgService: IReportWorkflowExamService;
    visitService: IReportWorkflowExamService;
    ecgSignData: SeSignRequestData;
    visitSignData: SeSignRequestData;
    userId: string;
    print: boolean;
    addendum?: Addendum;
    isDeferred?: boolean;
    isFromWorklist?: boolean;
    displayedSettings?: EcgChartState;
};

export interface SignOptions {
    print?: boolean;
    isDeferred?: boolean;
    addendum?: Addendum;
    displayedSettings?: EcgChartState;
}
export interface ISissCloudUploadRequest {
    type: SignType;
    sissCloud: {
        reportIdList: string[];
        signerId: string;
        signerUsername: string;
        token: string;
    };
    isDeferred: boolean;
}
export interface ISissWayCloudUploadRequest {
    type: SignType;
    sissWayCloud: {
        reportIdList: string[];
        signerId: string;
        signerUsername: string;
        token: string;
        reportDocumentiList: {
            reportInfo: ISissReportInfo;
            patientInfo: ISissPatientInfo;
            obscurationInfo: ISissObscurationInfo;
        }[];
        idStruttura: string;
        idSubStruttura: string;
        codBrancaSpecialistica: string;
    };
    isDeferred: boolean;
}
export interface SissUploadDocumentData {
    reportIds: string[];
    reportDescrList: string[];
    signerId: string;
    signerUsername: string;
    token: string;
    reportDocumentiList: {
        reportInfo: ISissReportInfo;
        patientInfo: ISissPatientInfo;
        obscurationInfo: ISissObscurationInfo;
    }[];
    idStruttura: string;
    idSubStruttura: string;
    codBrancaSpecialistica: string;
    isDeferred?: boolean;
}
export enum SignResultStatus {
    Failed = 0,
    Ok = 1,
    PdfGenerationFailed = 2,
    P7mGenerationFailed = 3,
    Locked = 4,
    Unlocked = 5,
}
export interface AuthData {
    userName: string;
    password: string;
    domain: string;
}
